import * as constants from './Achievements.constants';
import * as services from './Achievements.service';

const state = {
  checkData: {},
  isRequest: false,
};

const mutations = {
  [constants.POST_ACHIEVEMENTS_CHECK_SUCCESS](state, checkData) {
    if (undefined !== checkData && null !== checkData) {
      state.checkData = checkData;
    }
  },

  [constants.DUMMY_MUTATION]() {},

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async postAchievementsCheck({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const params = services.postAchievementsCheck(payload);
    const res = await params;
    commit(constants.POST_ACHIEVEMENTS_CHECK_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return params;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
